'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('../_virtual/_tslib.js');
var jsxRuntime = require('react/jsx-runtime');
var React = require('react');
var classNames = require('classnames/bind');
var Spinner = require('../Spinner/Spinner.js');
var Button_module = require('./Button.module.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

var cx = classNames__default["default"].bind(Button_module["default"]);
var Button = function (_a, ref) {
    var block = _a.block, children = _a.children, className = _a.className, disabled = _a.disabled, iconProp = _a.icon, _b = _a.iconPlacement, iconPlacement = _b === void 0 ? 'before' : _b, loading = _a.loading, _c = _a.size, size = _c === void 0 ? 'md' : _c, _d = _a.shape, shape = _d === void 0 ? 'default' : _d, _e = _a.type, type = _e === void 0 ? 'button' : _e, _f = _a.variant, variant = _f === void 0 ? 'primary' : _f, rest = _tslib.__rest(_a, ["block", "children", "className", "disabled", "icon", "iconPlacement", "loading", "size", "shape", "type", "variant"]);
    var icon = loading ? jsxRuntime.jsx(Spinner["default"], {}) : iconProp;
    return (jsxRuntime.jsxs("button", _tslib.__assign({ "aria-busy": loading, className: cx(className, 'main', "size-".concat(size), "variant-".concat(variant), {
            block: block,
            circle: shape === 'circle',
            disabled: disabled,
            'icon-after': iconPlacement === 'after',
            'icon-only': icon && !children,
            loading: loading,
        }), disabled: disabled || loading, ref: ref, 
        // eslint-disable-next-line react/button-has-type
        type: type }, rest, { children: [icon && jsxRuntime.jsx("span", _tslib.__assign({ className: Button_module["default"].contentItem }, { children: icon })), children && jsxRuntime.jsx("span", _tslib.__assign({ className: Button_module["default"].contentItem }, { children: children }))] })));
};
var Button$1 = React.forwardRef(Button);

exports["default"] = Button$1;
//# sourceMappingURL=Button.js.map
